/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Models_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update team models. Please try again." |
*
* @param {Team_Models_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_models_save_error = /** @type {((inputs?: Team_Models_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Models_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team-Modelle konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update team models. Please try again.")
});